export default __webpack_public_path__ + "img/dash.d221c46f.jpg";